import { IPaintShop, PaintShopApi } from '@/service/api'

class PaintShopRepository {
  public async fetchAll (): Promise<IPaintShop[]> {
    return await paintShopApi.getAllPaintShops().then(response => response.data)
  }
}

const paintShopApi = new PaintShopApi()
const paintShopRepository = new PaintShopRepository()
export default paintShopRepository
